import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PiezaDesgasteCalculationModel } from '../../../../models/pieza-desgaste-calculation';
import { PiezaDesgasteOptionCalculationModel } from '../../../../models/pieza-desgaste-option-calculation';
import { PiezaDesgasteHtmlService } from '../../../../services/pieza-desgaste-html.service';

@Component({
  templateUrl: './pieza-desgaste-modal.component.html',
  styleUrls: ['./pieza-desgaste-modal.component.scss']
})

export class PiezaDesgasteModalComponent implements OnInit {

  @Input() pieza: PiezaDesgasteCalculationModel;
  htmlInfo: SafeHtml;
  showOptions = false;
  selectedOption: string;

  constructor(public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private service: PiezaDesgasteHtmlService) { }

  ngOnInit() {

    this.selectedOption = this.pieza.CupraPiezaDesgasteOptions.find(x => x.Included).OptionCode;

    if (this.pieza.HasHtml != null) {
      this.getHtml();
    }

    if (this.pieza.CupraPiezaDesgasteOptions.length > 1) {
      this.showOptions = true;
    }

  }

  getHtml() {
    this.service.getFiles(this.pieza.IdHtml).subscribe((file) => {
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        this.htmlInfo = this.sanitizer.bypassSecurityTrustHtml(fileReader.result.toString());
      }
      fileReader.readAsText(file);
    });
  }

  includePieza() {
    this.pieza.Included = !this.pieza.Included;
    this.activeModal.close(this.pieza);
  }

  changeSelectedOption(option: PiezaDesgasteOptionCalculationModel) {
    this.selectedOption = option.OptionCode;
    this.pieza.Included = false;
    this.pieza.CupraPiezaDesgasteOptions = this.pieza.CupraPiezaDesgasteOptions.map(({ Included, ...rest }) => ({ ...rest, Included: false }));
    this.pieza.CupraPiezaDesgasteOptions.find(x => x.OptionCode == option.OptionCode).Included = true;
    this.UpdatePiezaOptionData();
  }

  UpdatePiezaOptionData() {
    this.pieza.SelectedOptionDesc = this.pieza.CupraPiezaDesgasteOptions.find(x => x.Included).Description;
    this.pieza.SelectedOptionPrice = this.pieza.CupraPiezaDesgasteOptions.find(x => x.Included).FinalPrice;
  }

}
